import type { EntityAnnotationBatch } from '@atlassian/conversation-assistant-content-transformer/entity-annotations';

export type EntityAnnotationCounts = {
	inferredProjectEntityAnnotationCount: number;
	personEntityAnnotationCount: number;
};

export const addEntityAnnotationBatchCounts = (
	counts: EntityAnnotationCounts,
	batch: EntityAnnotationBatch,
): EntityAnnotationCounts => {
	let inferredProjectEntityAnnotationCount = counts.inferredProjectEntityAnnotationCount;
	let personEntityAnnotationCount = counts.personEntityAnnotationCount;

	for (const entity of batch.entities) {
		if (entity.type === 'Person') {
			personEntityAnnotationCount += 1;
		} else if (entity.type === 'InferredProject') {
			inferredProjectEntityAnnotationCount += 1;
		}
	}

	return { inferredProjectEntityAnnotationCount, personEntityAnnotationCount };
};
